<app-header />

@if (export) {
  <mat-card style="margin: 0 var(--global-padding)">
    <mat-card-header>
      <mat-card-title>Export summary (Still under development)</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      {{ export | json }}
    </mat-card-content>
  </mat-card>
}
